export const GET_USER_LOGS_REQUEST = "GET_USER_LOGS_REQUEST";
export const GET_USER_LOGS_SUCCESS = "GET_USER_LOGS_SUCCESS";
export const GET_USER_LOGS_FAILURE = "GET_USER_LOGS_FAILURE";

export const GET_USER_LOGS_BY_USER_ID_REQUEST = "GET_USER_LOGS_BY_USER_ID_REQUEST";
export const GET_USER_LOGS_BY_USER_ID_SUCCESS = "GET_USER_LOGS_BY_USER_ID_SUCCESS";
export const GET_USER_LOGS_BY_USER_ID_FAILURE = "GET_USER_LOGS_BY_USER_ID_FAILURE";

export const GET_USER_LOGS_BY_IP_REQUEST = "GET_USER_LOGS_BY_IP_REQUEST";
export const GET_USER_LOGS_BY_IP_SUCCESS = "GET_USER_LOGS_BY_IP_SUCCESS";
export const GET_USER_LOGS_BY_IP_FAILURE = "GET_USER_LOGS_BY_IP_FAILURE";

